import http from './axios';

export default class AnalyzeServices {
  private readonly overview_api = '/v1/analyze-dashboard/overview';
  private readonly trend_api = '/v1/analyze-dashboard/trend';

  constructor() {}

  /**
   * @param groupByField=ind_second_level
   * @param condition=10
   * @param whereField=ind_first_level
   * @param type=part
   * @param dictCode=DICT_JOURNEY_SUB_SCENE
   */
  async getOverview(params?: object): Promise<any> {
    let res: any = await http.get(this.overview_api, { params: params });
    return res.payload;
  }

  async getTrend(params?: object): Promise<any> {
    let res: any = await http.post(this.trend_api, params);
    return res.payload;
  }

  // 客户旅程仪表盘    overview?groupByField=ind_first_level&condition=&whereField=&type=all&dictCode=DICT_JOURNEY_SCENE
  // 产品管理         overview?groupByField=ind_second_level&condition=10&whereField=ind_first_level&type=part&dictCode=DICT_JOURNEY_SUB_SCENE
  // 板块仪表盘       overview?groupByField=ind_owner_plate&condition=&whereField=&type=all&dictCode=DICT_BUSINESS_UNIT
  // 渠道板块         overview?groupByField=ind_owner_dept&condition=0&whereField=ind_owner_plate&type=part&dictCode=DICT_BUSINESS_DEPT
  // 客户旅程及管理板块趋势   trend?dataDate=2021-04-25&startTime=2021-04-25&endTime=2021-04-30&type=all&whereField&condition
  // 产品管理趋势       trend?dataDate=2021-04-25&startTime=2021-04-25&endTime=2021-04-30&type=part&whereField=ind_first_level&condition=10
  // 渠道板块趋势     trend?dataDate=2021-04-25&startTime=2021-04-25&endTime=2021-04-30&type=part&whereField=ind_owner_plate&condition=0
}
